// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__jNaPx","text":"SelectPayment_text__BsObd","title":"SelectPayment_title__1f8Qv","btn":"SelectPayment_btn__15gc7"};